import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { IFormModel } from "@cayo/shared/components/Form/modelUtils/types";
import { isObject } from "@cayo/shared/types/typeGuards";

export function normalizeModelForComplexType(data: Entity, model: IFormModel) {
  const result: Record<string, any> = {};

  for (const key in model) {
    if (Object.prototype.hasOwnProperty.call(model, key)) {
      const element = model[key];

      if (element === undefined || element === null) {
        continue;
      }

      const hasODataProp = !!element["@odata.type"];

      if (isObject(element) && !(element instanceof Date)) {
        const base = isObject(data[key]) && !hasODataProp ? { ...data[key] } : {};

        // Build a lookup of element keys in lowercase
        const elementKeys = new Set(Object.keys(element).map((k) => k.toLowerCase()));

        // Remove props from base if they match (case-insensitive)
        for (const prop in base) {
          if (elementKeys.has(prop.toLowerCase())) {
            delete base[prop as keyof typeof base];
          }
        }

        result[key] = {
          ...base,
          ...element, // overwrite with new values
        };
      } else {
        result[key] = element;
      }
    }
  }

  return result;
}
